import { NectDefaultTheme } from './nect-default';
import { Elevation, ITheme, ShadowColor, SpacingProp } from '.';

export const propToBoxShadow = (
    elevation: Elevation,
    shadowColor: ShadowColor | undefined,
    theme: ITheme,
) => {
    return `box-shadow: ${theme.elevation.shadow[elevation]} ${
        theme.elevation.color[shadowColor ?? 'light'][elevation]
    };`;
};

export const spacingPropToCSS = (
    prop: SpacingProp,
    type: 'margin' | 'padding',
    theme: ITheme,
) => {
    if (typeof prop === 'string') {
        return `${`${type}:${theme.spacing[prop]}`};`;
    }

    let bottom = '';
    if (prop.bottom) {
        bottom = `${type}-bottom: ${theme.spacing[prop.bottom]};`;
    }
    let top = '';
    if (prop.top) {
        top = `${type}-top: ${theme.spacing[prop.top]};`;
    }
    let left = '';
    if (prop.left) {
        left = `${type}-left: ${theme.spacing[prop.left]};`;
    }
    let right = '';
    if (prop.right) {
        right = `${type}-right: ${theme.spacing[prop.right]};`;
    }

    return `${bottom}${top}${left}${right}`;
};

export const SpacingStorybookPicker = {
    control: {
        type: 'select',
        options: Object.keys(NectDefaultTheme.spacing),
    },
};

export const BorderRadiusStorybookPicker = {
    control: {
        type: 'select',
        options: Object.keys(NectDefaultTheme.borderRadius),
    },
};
